import { Box } from '@wix/design-system'
import React, { FC } from 'react'

import { Heading } from '../../reusable/Heading/Heading'
import { dataHooks } from './WixIntrosBoxXL.dataHooks'

export const Title: FC = ({ children }) => {
  return (
    <Box marginBottom="SP7">
      <Heading size="xxxl" dataHook={dataHooks.title()}>
        {children}
      </Heading>
    </Box>
  )
}
